import React, { Fragment, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, Input, Card } from "reactstrap";
import errorProfile from "../.././assets/images/blank_profile.png";
import moment from "moment";
import ScrollBars from "react-custom-scrollbars-2";
import "react-datetime/css/react-datetime.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./AddNewPatient.scss";
import { InputGroup } from "react-bootstrap";
import { getPatients as getPatientBySearch, getPatientsHospital } from "../InvestigationReport/services/report-service";
import { TfiEmail } from "react-icons/tfi";
import { FiPhoneCall } from "react-icons/fi";
import { FaLocationDot } from "react-icons/fa6";
import { useLoader } from "../../_helper/LoaderContext";
import { toast } from "react-toastify";
import S3ImageLoader from "../../S3ImageLoader";
import { json } from "react-router";
import { useLab } from "../../_helper/PharmacyProvider";
const imageBaseURL = process.env.REACT_APP_BASE_URL;

const SearchPatientModel = ({
  searchQuery,
  setSearchQuery,
  isPatientModal,
  setIsPatientModal,
  handleSelectPatient,
  customerType
}) => {
  const { t } = useTranslation();
  const { setLoading } = useLoader();
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [searchPatients, setSearchPatients] = useState([]);
  const autocompleteRef = useRef(null);
  const { currentLab } = useLab()

  useEffect(() => {
    if (isPatientModal && searchQuery.length >= 3) {
      if (customerType === "walking") {
        getPatientsList();
      } else {
        getPatientsListHospital()
      }
    }
  }, [isPatientModal, searchQuery]);

  // Function to calculate age using Moment.js
  const calculateAge = (birthDate) => {
    const birthDateMoment = moment(birthDate); // Parse the birth date
    const currentDate = moment(); // Get the current date
    // Calculate the difference in years
    const age = currentDate.diff(birthDateMoment, "years");
    return age;
  };

  const handleCloseModal = () => {
    setIsPatientModal(false);
    setSearchQuery("");
  };

  const getPatientsList = async () => {
    try {
      setLoading(true);
      const form_data = new FormData();
      form_data.append("search", searchQuery)
      form_data.append("clinic_id", currentLab.hospital_id)
      const response = await getPatientBySearch(form_data);
      console.log(response)
      if (response.data.success == true) {
        setSearchPatients(response.data.data.patients || []);
      } else {
        setSearchPatients([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.warning(error.message);
    } finally {
      setLoading(false);
      setSkeletonLoading(false);
    }
  };

  const getPatientsListHospital = async () => {
    try {
      setLoading(true);
      const form_data = new FormData();
      form_data.append("search", searchQuery)
      form_data.append("clinic_id", currentLab.hospital_id)
      const response = await getPatientsHospital(form_data);
      console.log(response)
      if (response.data.success == true) {
        setSearchPatients(response.data.data.patients || []);
      } else {
        setSearchPatients([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.warning(error.message);
    } finally {
      setLoading(false);
      setSkeletonLoading(false);
    }
  };

  const handlePatientSearch = (event) => {
    event.preventDefault();

    if (searchQuery.length >= 3) {
      setSkeletonLoading(true);
      getPatientsList();
    } else {
      setSearchPatients([]);
    }
  };

  const handlePatientClick = async (patient) => {
    handleSelectPatient(patient);
    // console.log(patient)
    // localStorage.setItem("patient",JSON.stringify(patient))
  };

  const [containerHeight, setContainerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setContainerHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Fragment>
      <Modal
        isOpen={isPatientModal}
        keyboard={false}
        toggle={() => {
          setIsPatientModal(false);
        }}
        size="lg"
        centered
        backdrop="static"
      >
        <ModalBody>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h6 className="mb-0">
                <strong>{t("Search Patients")}</strong>
              </h6>
            </div>
            <div>
              <i
                onClick={handleCloseModal}
                className="fa fa-times-circle"
                aria-hidden="true"
                style={{ cursor: "pointer", fontSize: "24px" }}
              ></i>
            </div>
          </div>
          <hr />
          <div className="row">
            <>
              <div className="mt-2 col-md-12">
                <form
                  onSubmit={handlePatientSearch}
                  style={{ background: "none", flex: 1 }}
                  className="me-2"
                >
                  <InputGroup className="custom-input-group">
                    <Input
                      type="search"
                      className="search-bar patient-search-bar tw-rounded-s-full"
                      placeholder={t(
                        "Search Patient by NAKBHO ID / Name / Email / Phone"
                      )}
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <InputGroup.Text
                      onClick={handlePatientSearch}
                      className="text-white patient-search-icon-btn tw-rounded-e-full"
                      style={{
                        background:
                          "linear-gradient(180.05deg, #2B3A8F 20.14%, #1B255B 87.13%)",
                        borderColor: "var(--theme-default) !important",
                      }}
                    >
                      <i
                        className="fa fa-search"
                        style={{
                          fontSize: "14px",
                          height: "22px",
                          width: "16px",
                        }}
                      ></i>
                    </InputGroup.Text>
                  </InputGroup>
                </form>
              </div>
              <div
                className="col-md-12"
                style={{ borderLeft: "1px solid #A5A7AA" }}
                ref={autocompleteRef}
              >
                <div className="pt-3 row">
                  {skeletonLoading ? (
                    [...Array(4)].map((_, index) => (
                      <div className="col-md-6" key={index}>
                        <Card className="patient-card-background">
                          <div className="p-3 d-flex">
                            <Skeleton circle height={60} width={60} />
                            <div className="ms-3 flex-grow-1">
                              <Skeleton height={16} width={`80%`} />
                              <Skeleton height={12} width={`60%`} />
                              <Skeleton
                                height={14}
                                width={`50%`}
                                className="mt-2"
                              />
                            </div>
                          </div>
                          <div className="px-3 pb-3">
                            <Skeleton
                              height={12}
                              width={`90%`}
                              className="mb-2"
                            />
                            <Skeleton height={12} width={`70%`} />
                          </div>
                        </Card>
                      </div>
                    ))
                  ) : searchPatients.length > 0 ? (
                    <>
                      <ScrollBars
                        className="vertical-scroll scroll-demo"
                        style={{
                          height: `${containerHeight * 0.75}px`,
                          overflowX: "hidden",
                        }}
                      >
                        <div
                          className="m-0 row"
                          style={{ overflowX: "hidden" }}
                        >
                          {searchPatients.map((patient, index) => (
                            <div className="mb-3 col-md-6">
                              <Card style={{ border: "2px solid #1b255b", height: "100%" }} className="tw-cursor-pointer"
                                onClick={() => handlePatientClick(patient)}
                                key={index}
                              >
                                <div className="p-2">
                                  <div className="d-flex">
                                    <S3ImageLoader
                                      fileName={patient?.profile_picture}
                                      fallbackSrc={errorProfile}
                                      className="patient-pic img-60"
                                      alt="Patient"
                                    />
                                    <div className="ps-3">
                                      <h6 className="mb-0">
                                        <strong>
                                          {patient?.fname || patient.full_name}{" "}
                                        </strong>
                                      </h6>
                                      <small
                                        style={{
                                          fontSize: "12px",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {patient?.gender},{" "}
                                        {patient?.age && (
                                          <>
                                            {t("Age")} {patient?.age}
                                          </>
                                        )}
                                      </small>
                                      <div className="patient-healthId-text">
                                        {patient?.uniqueId
                                          ?.match(/.{1,4}/g)
                                          .join(" ")}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="my-1">
                                    <div className="row">
                                      {patient?.contact && (
                                        <div className="col-md-6">
                                          <div className="d-flex align-items-center">
                                            <div className="p-0 rounded-circle me-2">
                                              <FiPhoneCall />
                                            </div>
                                            <span style={{ fontSize: "12px" }}>
                                              {patient?.contact}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                      {patient?.email && (
                                        <div className="col-md-12">
                                          <div className="d-flex align-items-center">
                                            <div className="p-0 rounded-circle me-2">
                                              <TfiEmail />
                                            </div>
                                            <span style={{ fontSize: "12px" }}>
                                              {patient?.email}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                      {patient?.address && (
                                        <div className="col-md-12">
                                          <div className="d-flex align-items-center">
                                            <div className="p-0 rounded-circle me-2">
                                              <FaLocationDot />
                                            </div>
                                            <label className="mb-0">
                                              <small>{patient?.address}</small>
                                            </label>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </Card>
                            </div>
                          ))}
                        </div>
                      </ScrollBars>
                    </>
                  ) : (
                    <div className="col-md-12">
                      <Card className="my-3 patient-card-background">
                        <div className="p-4">
                          <h6 className="text-center">
                            {t("No patient records found.")}
                          </h6>
                        </div>
                      </Card>
                    </div>
                  )}
                </div>
              </div>
            </>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default SearchPatientModel;
